import BackButton from "app/components/BackButton/BackButton";
import React from "react";
import { FormattedMessage } from "react-intl";

//
function ManageFundingDesktopHeader(
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<"div">, "div"> {
  return (
    <div className="manage-funding__header">
      <div className="manage-funding__header__title">
        <BackButton className="title__back" history={props.history} />
        <FormattedMessage tagName="span" id="cashier-managefunding" />
        <div />
      </div>
    </div>
  );
}

export default ManageFundingDesktopHeader;
